module.exports = __webpack_public_path__ + "static/media/top-view-smiley-face-growth-arrow 1.115623b3.png";